import { render, staticRenderFns } from "./TwoParagraphsText.vue?vue&type=template&id=8e3c9122"
import script from "./TwoParagraphsText.vue?vue&type=script&lang=js"
export * from "./TwoParagraphsText.vue?vue&type=script&lang=js"
import style0 from "./TwoParagraphsText.vue?vue&type=style&index=0&id=8e3c9122&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports